import { Card, CardBody, Col } from 'reactstrap'
import { DonutChart } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { dountChartData } from '../../../../Data/Charts/ApexChart/ApexChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const DonutCharts = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={DonutChart} />
        <CardBody>
          <div id="donutchart">
            <ReactApexChart options={dountChartData} series={dountChartData.series} type="pie" height={300} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default DonutCharts